import { css } from '@emotion/react';
import {
  TinyMapPlaceholderShape, type TinyMapPlaceholderSize,
} from './tinyMapPlaceholder.component';
import { getContainerDimension } from './tinyMapPlaceholder.helpers';

const getContainerDimensionCss = (size: TinyMapPlaceholderSize) => {
  const dimension = getContainerDimension(size);
  return css({
    height: dimension,
    width: dimension,
    minHeight: dimension,
    minWidth: dimension,
  });
};

export const getContainerCss = (size: TinyMapPlaceholderSize) => css([
  getContainerDimensionCss(size),
  {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    borderRadius: 4,
    flexShrink: 0,
  },
]);

export const markerMapPlaceholderStyle = (shape?: TinyMapPlaceholderShape) => css({
  height: '100%',
  left: 0,
  objectFit: 'cover',
  position: 'absolute',
  top: 0,
  width: '100%',
  ...(shape === TinyMapPlaceholderShape.Circle ? { clipPath: 'circle(48% at 50% 50%)' } : {}),
});
